import { lazyWithRetry } from 'common/utils';

export * from './routes';

export const NatalieListPage = lazyWithRetry(() => import('./NatalieList'));

export const NatalieWizardPage = lazyWithRetry(() => import('./NatalieWizard'));

export const NatalieChooseIntakeModePage = lazyWithRetry(() => import('./NatalieAdmin/ChooseIntakeMode'));

export const NatalieCreateIntakePage = lazyWithRetry(() => import('./NatalieAdmin/CreateIntake'));

export const NatalieCreateIntakeFormPage = lazyWithRetry(() => import('./NatalieAdmin/CreateIntakeForm'));

export const NatalieSelfServeSetupPage = lazyWithRetry(() => import('./NatalieAdmin/SelfServeCreate/Setup'));

export const NatalieSelfServeReviewPage = lazyWithRetry(() => import('./NatalieAdmin/SelfServeCreate/Review'));

export const NatalieSelfServeSummaryPage = lazyWithRetry(() => import('./NatalieAdmin/SelfServeCreate/Summary'));

export const NatalieForParticipantPage = lazyWithRetry(() => import('./NatalieForParticipant'));

export const NatalieEventDetailsPage = lazyWithRetry(() => import('./NatalieEventDetails'));

export const NatalieNextHandoffPage = lazyWithRetry(() => import('./NatalieNextHandoff'));
